<template>
  <AgentComponent>
    <slot v-if="translationToolsActive" />
  </AgentComponent>
</template>

<script setup lang="ts">
const localeStore = useLocaleStore()
const { translationToolsActive } = storeToRefs(localeStore)
</script>